import React,{useState,useEffect} from 'react'

import TableComponent from '../../Global Functions/tableComponents';
import { columnsConsultant } from '../../Global Functions/columnsAntd';
import { consultantList } from '../../Redux/Actions/consultantAction';
import { useDispatch,useSelector} from   'react-redux';
import { useNavigate } from 'react-router-dom'; 
const ListConsultant = () => {
  const dispatch=useDispatch()
  const Navigate =useNavigate()
  const [searchQuery,setSearchQuery]=useState("")
    const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 10,
      total: 0,
    });
    const  viewConsultant=(record)=>{
      Navigate("/Consultants/view")

    }
    const columnHead=columnsConsultant(viewConsultant)
const list=useSelector((state)=>state.consultantList.plan)
      const fetchDetails = (page, limit, filter) => {
        const Data = {
          page,
          limit,
          is_deleted: false,
        
        };
       dispatch(consultantList(Data))
      };
  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setPagination((prev) => ({ ...prev, current: 1 }));
    fetchDetails(1, pagination.pageSize, searchQuery);
  };

    useEffect(() => {
      if (list) {
        setPagination((prevData) => ({ ...prevData, total: list }));
      }
    }, [list]);
useEffect(()=>{
 fetchDetails(pagination.current, pagination.pageSize);
},[])
  return (
    <div>
      <TableComponent
         h3heading="Consultants"
            setState={setSearchQuery}
            filterFunction={filterHandler}
            buttonhead2="Add Consultant"
          navigateTo2="/Consultants/add"
            dataSource={list?.data}
            pagination={pagination}
            onChange={handleTableChange}
           columns={columnHead}
      />
    </div>
  )
}

export default ListConsultant
